import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { getRateColor } from 'helpers/slaMonitor'
import { fetchCageList, setActiveCage } from 'reducers/slaMonitor/reducer'
import { getTime } from 'helpers/timeFrames'

class CageContainer extends Component {
  componentDidMount() {
    const { activeSite, activeDate } = this.props
    this.getComponentData(activeSite, activeDate.format('YYYY-MM-DD'))
  }

  shouldComponentUpdate(nextProps) {
    const { activeSite, activeDate } = this.props

    if (
      activeSite !== nextProps.activeSite ||
      activeDate !== nextProps.activeDate ||
      nextProps.isReloadCageList
    ) {
      this.getComponentData(
        nextProps.activeSite,
        nextProps.activeDate.format('YYYY-MM-DD'),
      )
    }

    return true
  }

  getComponentData = (siteId, date) => {
    if (siteId > 0) {
      this.props.fetchCageList({ siteId, date })
    }
  }

  onSetActiveCage = e => {
    const { setActiveCage, cageList } = this.props
    const cageIndex = +e.currentTarget.dataset.cage
    const cage = cageList.get(cageIndex)

    setActiveCage(cage.id)
  }

  renderCageBlock = ({ id, name, rate, hour, minute }, i) => {
    // eslint-disable-next-line no-param-reassign
    if (rate === null) rate = 0
    const value = Math.round(rate * 10) / 10

    return (
      <div
        key={i}
        data-cage={i}
        className="cage-block"
        onClick={this.onSetActiveCage}>
        <div
          className={cn('cage-info', {
            selected: this.props.activeCage === id,
          })}>
          <div className={`cage-rate ${getRateColor(rate)}`}>
            {value === 5 ? 'X' : value}
          </div>
          <div className="cage-name">{name}</div>
          {hour !== null && minute !== null && (
            <div className="cage-name">{getTime(hour, minute)}</div>
          )}
        </div>
      </div>
    )
  }

  render() {
    const cageList = this.props.cageList.toArray()

    return (
      <div className="cage-container">{cageList.map(this.renderCageBlock)}</div>
    )
  }
}

export default connect(
  state => ({
    isReloadCageList: state.getIn(['slaMonitor', 'isReloadCageList']),
    cageList: state.getIn(['slaMonitor', 'cageList']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    activeCage: state.getIn(['slaMonitor', 'activeCage']),
    activeSite: state.getIn(['profile', 'siteId']),
  }),
  {
    fetchCageList,
    setActiveCage,
  },
)(CageContainer)
